import { render, staticRenderFns } from "./QuotesGroups.vue?vue&type=template&id=1a02f08f&scoped=true"
import script from "./QuotesGroups.vue?vue&type=script&lang=js"
export * from "./QuotesGroups.vue?vue&type=script&lang=js"
import style0 from "./QuotesGroups.vue?vue&type=style&index=0&id=1a02f08f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a02f08f",
  null
  
)

export default component.exports